import { t } from "../hooks/translations"
import css from "../style.module.scss"

export const WeatherSummary = () => (
  <div className={css["summary-container"]}>
    <h3 className={css["summary-title"]}>{t("weather_title")}</h3>
    <p className={css["summary-text"]}>{t("weather_text")}</p>
  </div>
)
